import React, { useCallback, useMemo } from 'react';
import { Card, Form, Input, Select } from '../../../../components';
import { isValidIP } from '../../../../lib/helpers';

const PUBLIC_IP_OPTIONS = [
    { value: 'enable', label: 'Enable' },
    { value: 'disable', label: 'Disable' },
];

const validateStaticPrivateIp = async (_rule, value) => {
    if (value && !isValidIP(value)) {
        throw new Error('Static Private IP must be a valid IP address');
    }
};

export const AWSNetworkConfig = ({ networks = [], disabled = false, title = 'Network Adapter', onSubnetChange }) => {
    const form = Form.useFormInstance();
    const selectedSubnet = Form.useWatch('subnet', form);

    const subnetOptions = useMemo(
        () =>
            networks.map((subnet) => ({
                value: subnet.id || subnet.name,
                label: `${subnet.id || subnet.name} (${subnet.cidr_block})${subnet.name ? ` | ${subnet.name}` : ''}${
                    subnet.availability_zone ? ` | ${subnet.availability_zone}` : ''
                }`,
            })),
        [networks],
    );

    const handleSubnetChange = useCallback(
        (value) => {
            const subnet = networks.find((candidate) => (candidate.id || candidate.name) === value);
            form.setFieldValue('assignPublicIp', subnet?.map_public_ip ? 'enable' : 'disable');
            onSubnetChange?.(value);
        },
        [networks, form, onSubnetChange],
    );

    return (
        <Card title={title} size="small" className="network-config-card network-config-card--appliance">
            <Form.Item name="subnet" label="Subnet" rules={[{ required: true, message: 'Subnet is required' }]}>
                <Select
                    placeholder={networks.length === 0 ? 'Select a VPC first' : 'Select a Subnet'}
                    onChange={handleSubnetChange}
                    options={subnetOptions}
                    disabled={disabled || networks.length === 0}
                    showSearch={{ optionFilterProp: 'label' }}
                />
            </Form.Item>

            {selectedSubnet && (
                <>
                    <Form.Item name="assignPublicIp" label="Enable Public IP">
                        <Select options={PUBLIC_IP_OPTIONS} disabled={disabled} />
                    </Form.Item>

                    <Form.Item
                        name="staticPrivateIp"
                        label="Static Private IP"
                        rules={[{ validator: validateStaticPrivateIp }]}
                    >
                        <Input placeholder="Enter static private IP (optional)" disabled={disabled} />
                    </Form.Item>
                </>
            )}
        </Card>
    );
};

